import { useTheme } from "../../framework/theme/mantine-passthroughs.js";
import { Indicator } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/indicator/DotIndicator.tsx
const DotIndicator = ({ children, color = "primary", offset = 0, position = "top-end", disabled = false, "data-testid": testId }) => {
	return /* @__PURE__ */ jsx(Indicator, {
		disabled,
		color: useTheme().other.getStyleForColor(color).bg,
		offset,
		position,
		"data-testid": testId,
		children
	});
};

//#endregion
export { DotIndicator };